import React, { useCallback } from "react"
import { Translate } from "utils/i18n-shim"

import { useHandleDeleteActivityNote } from "./handlers"

export const useDeleteActivityNoteAction = () => {
  const handleDeleteActivityNote = useHandleDeleteActivityNote()

  return useCallback(
    (activityNote) => {
      return {
        label: <Translate value="delete.title" />,
        onClick: () => handleDeleteActivityNote(activityNote)
      }
    },
    [handleDeleteActivityNote]
  )
}
